/** Full-page contact detail URL (opens in app router). */
export const getContactDetailPath = (contactId: string): string =>
  `/admin/lead-management/contacts/${encodeURIComponent(contactId)}`;

/** Open the contact detail page in a new browser tab. */
export const openContactDetailInNewTab = (contactId: string): void => {
  window.open(getContactDetailPath(contactId), '_blank', 'noopener,noreferrer');
};
